/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, createContext, useEffect } from 'react';
import I18n from 'I18n';
import { localeOptions } from 'I18n/types';
import {
	addInitialValueTranslate,
	getInitialTimeZone,
	getInitialValueTranslate,
} from 'I18n/store';

export const I18nProviderContext = createContext({} as any);

export const I18nProvider = ({ children }: any): JSX.Element => {
	const [location, setLocation] = useState<any>('');
	const [timeZone, setTimeZone] = useState<any>('');

	const changeLocation = (newLocation: localeOptions) => {
		setLocation(newLocation);
		addInitialValueTranslate(newLocation);
	};

	useEffect(() => {
		const storeLocation = getInitialValueTranslate();
		const storeTimeZone = getInitialTimeZone();

		setTimeZone(storeTimeZone);
		setLocation(storeLocation);
	}, []);

	const { getTranslate, translate, formatTimezone } = I18n({
		defaultLocale: 'es',
		locale: location,
		timeZone,
		defaultTimeZone: 'America/Mexico_City',
	});

	return (
		<I18nProviderContext.Provider
			value={{
				getTranslate,
				translate,
				formatTimezone,
				changeLocation,
			}}
		>
			{children}
		</I18nProviderContext.Provider>
	);
};
